'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./HeaderDropDown.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderDropDown = function (_PureComponent) {
  (0, _inherits3.default)(HeaderDropDown, _PureComponent);

  function HeaderDropDown() {
    (0, _classCallCheck3.default)(this, HeaderDropDown);
    return (0, _possibleConstructorReturn3.default)(this, (HeaderDropDown.__proto__ || (0, _getPrototypeOf2.default)(HeaderDropDown)).apply(this, arguments));
  }

  (0, _createClass3.default)(HeaderDropDown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          menuContent = _props.menuContent,
          headerDropDownItemClass = _props.headerDropDownItemClass,
          menuContainerClass = _props.menuContainerClass,
          subMenuGroupClass = _props.subMenuGroupClass,
          isShowArrow = _props.isShowArrow;


      var headerDropDownClass = (0, _classnames2.default)('header-dropdown', headerDropDownItemClass);
      var iconClass = (0, _classnames2.default)('header-dropdown-icon', icon);
      var menuClass = (0, _classnames2.default)('header-dropdown__submenu', menuContainerClass);
      var menuGroupClass = (0, _classnames2.default)('header-dropdown__submenu-group', subMenuGroupClass);

      return _react2.default.createElement(
        'div',
        { className: headerDropDownClass },
        _react2.default.createElement('i', { className: iconClass }),
        _react2.default.createElement(
          'span',
          null,
          this.props.children
        ),
        isShowArrow ? _react2.default.createElement('i', { className: 'header-dropdown-arrow icon-caret' }) : '',
        _react2.default.createElement(
          'div',
          { className: menuClass },
          _react2.default.createElement(
            'menu',
            { className: menuGroupClass },
            menuContent
          )
        )
      );
    }
  }]);
  return HeaderDropDown;
}(_react.PureComponent);

exports.default = HeaderDropDown;